import { Modal } from 'react-bootstrap';
import ExpiredIcon from 'assets/img/verification/expired.svg';
import Button from 'components/base/Button';

interface Props {
  show: boolean;
  handleSubmit: () => void;
}

const LinkExpiredModal = ({ show, handleSubmit }: Props) => {
  return (
    <Modal show={show} onHide={handleSubmit} className="p-0" centered>
      <Modal.Body className="pt-4 pb-2 px-4">
        <div className="d-flex justify-content-center mb-2">
          <img src={ExpiredIcon} width={150} />
        </div>
        <h5 className="text-center fs-6">Verification Link Unavailable</h5>
        <p className="mt-3 text-center">
          It appears you’ve already verified your email or your verification
          link has expired. If you’ve already confirmed your account, please
          proceed to sign in. Otherwise, request a new verification link.
        </p>
        <div className="d-flex justify-content-center mb-2">
          <Button variant="outline-primary" onClick={handleSubmit}>
            Back to sign in
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LinkExpiredModal;
